import APIInvoke from '../../utils/APIInvoke'
import { escapeHtml } from './collectionFormat'

export const TEMPLATES = [
    {
        id: 'amable',
        label: 'Recordatorio amable',
        subject: 'Recordatorio de pago de tu póliza',
        body: (name, policy) => `Hola ${name}, te recordamos que tu recibo de la póliza ${policy} está próximo a vencer. Puedes pagar por transferencia o con tarjeta.`,
    },
    {
        id: 'vencido',
        label: 'Aviso de recibo vencido',
        subject: 'Tu recibo se encuentra vencido',
        body: (name, policy) => `Hola ${name}, tu recibo de la póliza ${policy} se encuentra vencido. Regulariza tu pago para mantener tu cobertura activa.`,
    },
    {
        id: 'ultimo',
        label: 'Último aviso antes de cancelación',
        subject: 'Último aviso de pago de tu póliza',
        body: (name, policy) => `Hola ${name}, este es el último aviso: si el recibo de la póliza ${policy} no se paga en los próximos 3 días, la póliza podrá ser cancelada por falta de pago.`,
    },
]

export const loadCliente = async (clienteId) => {
    const response = await APIInvoke.invokeGET(`/clientes/${clienteId}`)
    const payload = await response.json()
    if (!payload?.ok) throw new Error(payload?.message || 'No se pudo cargar el contacto del cliente.')
    return payload.body
}

export const sendReceiptEmail = async ({ from, to, subject, text, clienteId, polizaId, reciboId }) => {
    const response = await APIInvoke.invokePOST('/email/crm', {
        from,
        to,
        cc: [],
        bcc: [],
        subject,
        body: `<p>${escapeHtml(text).replace(/\n/g, '<br>')}</p>`,
        tipo: 'correo',
        clienteId,
        polizaId,
        reciboId,
    })
    const payload = await response.json()
    if (!payload?.ok) throw new Error(payload?.message || 'No se pudo enviar el correo.')
    return payload
}

export const openWhatsApp = (phone, text) => {
    const digits = String(phone || '').replace(/\D/g, '')
    if (!digits) return false
    window.open(`https://wa.me/${digits}?text=${encodeURIComponent(text)}`, '_blank', 'noopener,noreferrer')
    return true
}
